import { render, staticRenderFns } from "./PLCConnectionSettings.vue?vue&type=template&id=919bf5a8&scoped=true&"
import script from "./PLCConnectionSettings.vue?vue&type=script&lang=js&"
export * from "./PLCConnectionSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "919bf5a8",
  null
  
)

export default component.exports